import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    isDrawerOpen:true,
    initialState: {
        user: null
    },
    reducers: {
        loginSuccess: (state, action) => {
            state.user = action.payload;
        },
        setIsDrawer: (state, action) => {
            state.isDrawerOpen = action.payload;
        },
        logoutSuccess: (state) => {
            state.user = null;
        }
    }
});

export const { loginSuccess, logoutSuccess,setIsDrawer } = authSlice.actions;
export default authSlice.reducer;